import styled from 'styled-components'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'

import config from 'src/lib/config'
import { useEmblaContext } from 'src/emblaCarousel/EmblaContext'

interface PageProps {
	title?: string
	Component?: any
	setShowToastBackdrop?: (show: boolean) => void
}

const Page = ({ title, Component, setShowToastBackdrop }: PageProps) => {
	// const navigate = useNavigate()
	const emblaApi = useEmblaContext()

	const onIdle = () => {
		// Go back to start
		emblaApi?.scrollTo(0)
		// navigate('/')
		// window.location.reload()
	}

	useIdleTimer({
		timeout: config.idleTimeout,
		onIdle: onIdle,
	})

	return (
		<Content>
			{/* <Header>{title}</Header> */}
			<Header>
				<Logo
					src='https://res.cloudinary.com/kitchenmate/image/upload/v1712336365/Gen4/Portal/Default_Logo.svg'
					width={Math.round(446 * config.resize)}
					alt='Micromart Logo'
				/>
			</Header>
			<Component setShowToastBackdrop={setShowToastBackdrop} />
		</Content>
	)
}

const Header = styled.h1`
	margin: 0;
	margin-bottom: 20px;
	text-align: center;
`

const Logo = styled.img``

const Content = styled.div`
	padding: 2.7rem 2rem;
	padding-right: 0;
	padding-top: 2.7rem;
	flex: 1;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;
`

export default Page
